import PortfolioAssetField from "./PortfolioAssetField";

export default PortfolioAssetField;
